import { Modal } from 'react-bootstrap'
import styled, { createGlobalStyle } from 'styled-components'

export const ConfirmModalBackdropStyle = createGlobalStyle`
  .confirm-modal-backdrop.modal-backdrop {
    z-index: 1055;
  }
`

export const StyledConfirmSubmitModal = styled(Modal)`
  &.modal {
    z-index: 1060;
  }

  * {
    font-size: 14px;
  }

  display: flex;
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 4px;
  border-radius: 3px;
  padding: 10px;

  .modal-header {
    background-color: #003399;
  }

  .modal-title {
    font-weight: 600;
    margin-left: 15px;
    color: white;
  }

  label {
    display: contents;
  }

  button {
    float: right;
    margin-right: 20px;
    width: 120px;
  }

  .confirm-message-label {
    padding: 0px 15px 10px 15px;
  }

  .confirm-no-btn {
    background-color: #f5f5f5;
    color: black;
    border: none;
    padding: 5px 0;
  }

  .confirm-no-btn:hover {
    background-color: #f5f5f5;
    color: #003399;
  }

  .confirm-submit-btn {
    background-color: #003399;
    color: white;
    padding: 5px 0;
  }

  .confirm-submit-btn:hover {
    background-color: #002266;
  }
`

export const StyledConfirmMessageBody = styled.div`
  display: flex;
  margin-bottom: 8px;
`

export const StyledExclamationMark = styled.div`
  font-size: 25px;
  padding-right: 5px;
  color: red;
  margin-top: -5px;
`
